import { Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { IOption } from "@models/entity-models";

@Kbo(CToken.Option)
export class Option implements IOption {
    constructor() {

    }
    public value: any;
    public image: string;
    public imageWhenSelected: string;
    public label: string;
    public description: string;
}
